module.exports = __webpack_public_path__ + "media/images/banner/coupons/coupon02-zh-hant-1ac4e5d9e3f32d9a86c7983a3822a09e.png";